{
  "name": "iopoc-web",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --o",
    "start:dev": "ng serve --o --configuration=dev",
    "start:test": "ng serve --o --configuration=test",
    "start:qa": "ng serve --o --configuration=qa",
    "start:prod": "ng serve --o --configuration=prod",
    "build": "ng build",
    "build:dev": "ng build --configuration=dev",
    "build:test": "ng build --configuration=test",
    "build:qa": "ng build --configuration=qa",
    "build:prod": "ng build --configuration=prod",
    "validate:app-insights:prod": "node scripts/validate-app-insights-build.mjs dist/browser",
    "generate:engine-api": "ng-openapi-gen --input openapi/workflow-engine/engine-api.json --output src/services/workflow-engine/generated",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.2.5",
    "@angular/common": "22.2.4",
    "@angular/compiler": "22.2.4",
    "@angular/core": "22.2.4",
    "@angular/forms": "22.2.4",
    "@angular/platform-browser": "22.2.4",
    "@angular/router": "22.2.4",
    "@azure/msal-angular": "^4.0.26",
    "@azure/msal-browser": "^4.28.2",
    "@microsoft/applicationinsights-angularplugin-js": "^15.4.2",
    "@microsoft/applicationinsights-web": "^3.4.4",
    "chart.js": "^4.5.1",
    "ng2-charts": "^11.0.0",
    "primeicons": "^8.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "22.2.4",
    "@eslint/js": "^10.0.1",
    "@types/node": "^24.6.0",
    "@vitest/coverage-v8": "^5.0.5",
    "angular-eslint": "22.6.0",
    "eslint": "^10.3.0",
    "jsdom": "^30.0.1",
    "ng-openapi-gen": "^1.1.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.59.2",
    "vitest": "^5.0.5"
  },
  "overrides": {
    "undici@>=6.23.0 <6.29.1": "6.29.1",
    "undici@>=7.18.0 <7.30.1": "7.30.1",
    "undici@>=8.0.0 <8.12.2": "8.12.2",
    "minimatch": "^11.0.4",
    "glob@>=13.0.0 <14.0.0": "14.0.3"
  },
  "engines": {
    "node": "24.22.2"
  }
}
